import moment from 'moment';

import { Button, Table } from 'react-bootstrap';

import React from 'react';

import Bar from '../Bandwidth/Bar';
import BandwidthBarStore from '../../stores/Bandwidth/BarStore';
import BandwidthHistogramStore from '../../stores/Bandwidth/HistogramStore';
import Bullet from '../Chart/Bullet';
import Constants from '../../constants/Constants';
import cx from 'classnames';
import Ip from '../../util/Ip';
import Line from '../Bandwidth/Line';
import Loading from '../Loading';

function getState(service) {
    return {
        barUsage: BandwidthBarStore.getBandwidth(service),
        barLoading: BandwidthBarStore.loading(),
        historyUsage: BandwidthHistogramStore.getBandwidth(service),
        historyLoading: BandwidthHistogramStore.loading()
    }
}

var Bandwidth = React.createClass({
    propTypes: {
        /**
         * The service we will be rendering bandwidth information for.
         */
        service: React.PropTypes.object.isRequired
    },

    statics: {
        /**
         * Checks if the bandwidth block should be displayed for a given service.
         */
        bandwidthShouldDisplay: function (service) {
            if (service.shared_hosting) {
                return false;
            }
            var transit = service.transit;
            if (!transit) {
                return false;
            }

            if (transit.external_network) {
                return false;
            }

            var ips = Ip.usageIps(service);

            return Ip.filterPublic(ips).length > 0;
        },

        /**
         * Returns an object of bandwidth limits that are defined for a given service.
         * Each period and direction is returned as an array of numbers. The first number
         * is the base bandwidth limit defined by the service and any additional numbers
         * are the base number added to the previous bandwidth pack numbers.
         *
         * For example, a service with a 100GB base limit and a monthly bandwidth pack of
         * 50GB and a one off pack of 25GB would have the following under down_peak:
         *
         * [100000000000, 150000000000, 175000000000]
         */
        getLimits: function (service) {
            var transit = service.transit;
            var limits = {
                combined: [],
                down_offpeak: [],
                down_peak: [],
                up_offpeak: [],
                up_peak: [],
                threshold: transit.allowance_warning_threshold
            };

            if (transit.allowance_download_peak) {
                limits.down_peak.push(transit.allowance_download_peak);
            }
            if (transit.allowance_download_offpeak) {
                limits.down_offpeak.push(transit.allowance_download_offpeak);
            }
            if (transit.allowance_upload_peak) {
                limits.up_peak.push(transit.allowance_upload_peak);
            }
            if (transit.allowance_upload_offpeak) {
                limits.up_offpeak.push(transit.allowance_upload_offpeak);
            }

            if (transit.bandwidth_packs) {
                transit.bandwidth_packs.forEach(function (pack) {
                    if (pack.allowance_combined) {
                        limits.combined.push(pack.allowance_combined + (limits.combined[limits.combined.length - 1] || 0))
                    }
                    if (pack.allowance_download_peak) {
                        limits.down_peak.push(pack.allowance_download_peak + (limits.down_peak[limits.down_peak.length - 1] || 0));
                    }
                    if (pack.allowance_upload_peak) {
                        limits.up_peak.push(pack.allowance_upload_peak + (limits.up_peak[limits.up_peak.length - 1] || 0));
                    }
                });
            }

            // Any packs need to sum the array total so far and add their limit to a new
            // element to the end of the array relating to the direction/period.

            return limits;
        },
    },

    bandwidthUpdated: function () {
        this.setState(getState(this.props.service));
    },

    componentDidMount: function () {
        window.addEventListener("resize", this.updateDimensions);

        this.updateDimensions();
    },

    componentWillMount: function () {
        BandwidthBarStore.addChangeListener(this.bandwidthUpdated);
        BandwidthHistogramStore.addChangeListener(this.bandwidthUpdated);
    },

    componentWillUnmount: function () {
        window.removeEventListener("resize", this.updateDimensions);
        BandwidthBarStore.removeChangeListener(this.bandwidthUpdated);
        BandwidthHistogramStore.removeChangeListener(this.bandwidthUpdated);
    },

    getInitialState: function () {
        return getState(this.props.service);
    },

    render: function () {
        var limits = Bandwidth.getLimits(this.props.service);

        return <section>
            {this.renderBars(limits)}
            {this.renderHistory(limits)}
            {this.renderTable()}
        </section>;
    },

    renderBars: function (limits) {
        var service = this.props.service;
        var transit = service.transit;
        var usage = this.state.barUsage;
        var offpeakService = limits.down_offpeak.length || limits.up_offpeak.length;

        var period = moment.duration(transit.usage_interval);
        var periodStart = moment(transit.next_usage_period).subtract(period);
        var periodEnd = moment(transit.next_usage_period);
        var periodDays = periodEnd.diff(periodStart, 'days');
        var periodOver = moment().diff(periodStart, 'days');

        var bars = [];
        if (!this.state.width || this.state.barLoading) {
            bars = <Loading />
        } else if (!usage) {
            bars = <p>No usage reported.</p>;
        } else if (this.state.width) {
            if (limits.combined.length) {
                bars.push(<Bar key="down_peak"
                    limits={limits.combined}
                    nearThreshold={limits.threshold}
                    usage={usage.in_bytes_peak + usage.in_bytes_offpeak + usage.out_bytes_offpeak + usage.out_bytes_peak}
                    title="Usage"
                    width={this.state.width}
                />);
            }
            if (limits.down_peak.length) {
                var download = !limits.down_offpeak.length ?
                    usage.in_bytes_peak + usage.in_bytes_offpeak :
                    usage.in_bytes_peak;

                bars.push(<Bar key="down_peak"
                    limits={limits.down_peak}
                    nearThreshold={limits.threshold}
                    usage={download}
                    title={limits.down_offpeak.length ? "Download Peak": "Download"}
                    width={this.state.width}
                />);
            }
            if (limits.down_offpeak.length) {
                bars.push(<Bar key="down_offpeak"
                    limits={limits.down_offpeak}
                    nearThreshold={limits.threshold}
                    usage={usage.in_bytes_offpeak}
                    title="Download Offpeak"
                    width={this.state.width}
                />);
            }
            if (limits.up_peak.length) {
                var upload = !limits.down_offpeak.length ?
                    usage.out_bytes_peak + usage.out_bytes_offpeak :
                    usage.out_bytes_peak;

                bars.push(<Bar key="up_peak"
                    limits={limits.up_peak}
                    nearThreshold={limits.threshold}
                    usage={upload}
                    title={limits.up_offpeak.length ? "Upload Peak": "Upload"}
                    width={this.state.width}
                />);
            }
            if (limits.up_offpeak.length) {
                bars.push(<Bar key="up_offpeak"
                    limits={limits.up_offpeak}
                    nearThreshold={limits.threshold}
                    usage={usage.out_bytes_peak}
                    title="Upload Offpeak"
                    width={this.state.width}
                />);
            }

            bars.push(<div key="days-left" className="bandwidth-bar">
                <strong>Days Left:</strong> {periodDays - periodOver} days remaining

                <Bullet
                    ranges={[periodDays]}
                    measures={[periodOver]}
                    markers={[periodOver]}
                    width={this.state.width}
                    height={50} />
            </div>);
        }

        var shaped = [];
        if (transit.shaped_until_peak) {
            var peak = offpeakService ? " during peak" : '';
            shaped.push(<div key="shaped-peak" className="alert alert-warning">
                Your connection has been shaped{peak} until {moment(transit.shaped_until_peak).format(_DATE_FORMAT)}
            </div>);
        }
        if (transit.shaped_until_offpeak) {
            shaped.push(<div key="shaped-offpeak" className="alert alert-warning">
                Your connection has been shaped offpeak until {moment(transit.shaped_until_offpeak).format(_DATE_FORMAT)}
            </div>);
        }

        return <section>
            <h3>Usage Period ending {periodEnd.format(_DATE_FORMAT)}</h3>

            {shaped}
            {bars}
        </section>;
    },

    renderHistory: function (limits) {
        var chart;
        var usage = this.state.historyUsage;
        if (!this.state.width || this.state.historyLoading) {
            chart = <Loading />
        } else if (!usage || !usage.length) {
            chart = <p>No usage reported.</p>;
        } else if (this.state.width) {
            chart = <Line limits={limits} usage={usage} width={this.state.width} />;
        }

        return <section>
            <h3>Last 6 months usage</h3>

            {chart}
        </section>;
    },

    renderTable: function () {
        return <section>
            <p>
                <Button onClick={() => this.setState({showTable: !this.state.showTable})}>
                    Usage By Date <i className={cx({fa: true, 'fa-plus': !this.state.showTable, 'fa-minus': this.state.showTable})}></i>
                </Button>
            </p>
            {this.state.showTable && <div>
                <Table className="table-striped table-hover">
                    <thead><tr><th>Date</th><th style={{textAlign:'right'}}>Downloads</th><th style={{textAlign:'right'}}>Uploads</th></tr></thead>
                    <tbody>
                        {this.state.historyUsage.slice(-60).map(usageItem => {
                            const day = moment(usageItem.start);
                            const bytesIn  = usageItem.non_accumulative_totals.in_bytes_offpeak  + usageItem.non_accumulative_totals.in_bytes_peak;
                            const bytesOut = usageItem.non_accumulative_totals.out_bytes_offpeak + usageItem.non_accumulative_totals.out_bytes_peak;
                            const megabytesIn  = bytesIn  / 1000000;
                            const megabytesOut = bytesOut / 1000000;
                            return <tr key={day.format('YYYYMMDD')}>
                                <td>{day.format('D MMM YYYY')}</td>
                                <td style={{textAlign:'right'}}>{megabytesIn.toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2})} MB</td>
                                <td style={{textAlign:'right'}}>{megabytesOut.toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2})} MB</td>
                            </tr>;
                        })}
                    </tbody>
                </Table>
            </div>}
        </section>;
    },

    updateDimensions: function () {
        this.setState({
            width: this.getDOMNode().offsetWidth
        });
    }
})
module.exports = Bandwidth;



// WEBPACK FOOTER //
// ./app/components/ClientService/Bandwidth.js